import { Ctas, type SectionOf } from './shared'

export default function ListSection({ section }: { section: SectionOf<'list'> }) {
  const v = section.variant ?? 'bullet'
  return (
    <div className="max-w-3xl">
      {section.heading && (
        /* `whitespace-pre-line` so a heading can ask for its own line break
           with a newline in the copy — a two-sentence heading otherwise
           wraps wherever the measure happens to fall. Headings without one
           are unaffected. */
        <h2 className="whitespace-pre-line text-3xl font-bold tracking-tight sm:text-4xl">
          {section.heading}
        </h2>
      )}
      {section.sub && <p className="mt-4 text-lg text-muted-foreground">{section.sub}</p>}
      {section.intro && <p className="mt-6 text-lg leading-relaxed">{section.intro}</p>}
      <ul className={v === 'steps' ? 'mt-10 space-y-4' : 'mt-8 space-y-3'}>
        {section.items.map((it) => (
          <li
            key={it}
            className={
              v === 'steps'
                ? 'text-xl font-medium leading-snug'
                : 'flex gap-3 text-lg leading-relaxed'
            }
            /* `steps` lines run flush left, one under the other. They used to
               cascade — each line indented further than the last — which read
               as a staircase rather than as a sequence of sentences. */
          >
            {v !== 'steps' && (
              <span aria-hidden className="mt-[0.55rem] h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
            )}
            <span>{it}</span>
          </li>
        ))}
      </ul>
      {section.body && <p className="mt-8 text-lg leading-relaxed">{section.body}</p>}
      {section.cta && <Ctas items={[section.cta]} />}
    </div>
  )
}
